import {
  diagnosticsEnabled,
  logResourceTiming,
  measureDiagnosticStep,
  measureDiagnosticSync,
} from "./perfDiagnostics";

const LIVE_SALES_PERF_STORAGE_KEY = "vend:liveSalesPerf";

export const liveSalesPerfEnabled = () =>
  diagnosticsEnabled(LIVE_SALES_PERF_STORAGE_KEY, "liveSalesPerf");

export async function measureLiveSalesStep<T>(
  label: string,
  action: () => Promise<T>,
): Promise<T> {
  return measureDiagnosticStep(
    "live-sales-perf",
    label,
    liveSalesPerfEnabled(),
    action,
  );
}

export function measureLiveSalesSync<T>(label: string, action: () => T): T {
  return measureDiagnosticSync(
    "live-sales-perf",
    label,
    liveSalesPerfEnabled(),
    action,
  );
}

export const liveSalesPerfRangeLabel = (
  calendar?: { range?: string; startDate?: string; endDate?: string },
) =>
  calendar?.range ||
  (calendar?.startDate && calendar?.endDate ? "custom" : "timestamp");

export function logLiveSalesResourceTiming(
  label: string,
  urlFragment: string,
) {
  logResourceTiming(
    "live-sales-perf",
    label,
    urlFragment,
    liveSalesPerfEnabled(),
  );
}
